// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/public/common/img/menu-border-img.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@offlinecolor :rgba (0, 0, 0, 0.25);
:export {
  menuText: rgba(0, 0, 0, 0.5);
  menuActiveText: #fff;
  menuBg: #ffffff;
  menuHover: rgba(0, 0, 0, 0.05);
  subMenuBg: #ffffff;
  subMenuHover: rgba(0, 0, 0, 0.05);
  sideBarWidth: 200px;
}
.reset-style.ant-tooltip {
  max-width: 60vh;
}
.reset-style.ant-tooltip .ant-tooltip-inner {
  color: #000000 !important;
}
:root {
  --home-baidu-map-bg-color: #ffffff;
  --primary: #e8aa0d;
}
body :global {
  font-size: 12px;
}
.ant-radio-inner {
  background-color: #ffffff !important;
}
.ant-breadcrumb-link {
  font-size: 16px;
}
#root,
body,
html {
  height: 100%;
  background: var(--home-baidu-map-bg-color);
}
#root .width-100-percent,
body .width-100-percent,
html .width-100-percent {
  width: 100%;
}
#root .energy-diagram-text-value,
body .energy-diagram-text-value,
html .energy-diagram-text-value {
  fill: #454545;
  font-size: 16px;
  font-weight: 500;
}
body * {
  margin: 0;
  padding: 0;
}
body * .cus-red-star {
  display: inline-block;
  margin-right: 4px;
  color: #ff4d4f;
  font-size: 14px;
  font-family: SimSun, sans-serif;
  line-height: 1;
  content: '*';
}
body * .ant-form-item-mb-8 .ant-form-item {
  margin-bottom: 8px;
}
body * .alpha-cloud-SSO .ant-page-header-no-children {
  height: 0px !important;
}
body * .alpha-cloud-SSO.ant-pro-layout .ant-pro-layout-bg-list {
  background: #fff;
}
body * .alpha-cloud-SSO .ant-pro-page-container-children-container {
  padding: 0px !important;
  overflow: hidden;
}
body * .alpha-cloud-SSO .ant-pro-page-container-children-container::-webkit-scrollbar {
  display: none;
}
body * .unselect-word {
  -webkit-user-select: none;
  -moz-user-select: none;
  -o-user-select: none;
  -ms-user-select: none;
}
body * .ant-breadcrumb-link {
  font-weight: bold;
}
body * .flex {
  display: -webkit-box;
  /* Chrome 4+, Safari 3.1, iOS Safari 3.2+ */
  display: -moz-box;
  /* Firefox 17- */
  display: -webkit-flex;
  /* Chrome 21+, Safari 6.1+, iOS Safari 7+, Opera 15/16 */
  display: -moz-flex;
  /* Firefox 18+ */
  display: -ms-flexbox;
  /* IE 10 */
  display: flex;
}
body * .ant-table-cell-ellipsis .content-html.dg-html:not(ant-tooltip-open) {
  height: 15px;
  overflow: hidden;
}
body * .ant-table-cell-ellipsis .content-html.dg-html:not(ant-tooltip-open) * {
  font-size: 12.5px !important;
  line-height: 1.2 !important;
  margin: 0px !important;
  padding: 0px !important;
}
body * .ant-table-cell-ellipsis .content-html.dg-html:not(ant-tooltip-open) > :first-child {
  overflow: hidden;
  text-overflow: ellipsis;
}
#nprogress .bar {
  background: #e8aa0d !important;
}
input::placeholder input::-webkit-input-placeholder input::-moz-placeholder input::-moz-placeholder input::-ms-input-placeholder,
input::placeholder input::-webkit-input-placeholder input::-moz-placeholder input::-moz-placeholder textarea::-ms-input-placeholder,
input::placeholder input::-webkit-input-placeholder input::-moz-placeholder textarea::-moz-placeholder input::-ms-input-placeholder,
input::placeholder input::-webkit-input-placeholder input::-moz-placeholder textarea::-moz-placeholder textarea::-ms-input-placeholder,
input::placeholder input::-webkit-input-placeholder textarea::-moz-placeholder input::-moz-placeholder input::-ms-input-placeholder,
input::placeholder input::-webkit-input-placeholder textarea::-moz-placeholder input::-moz-placeholder textarea::-ms-input-placeholder,
input::placeholder input::-webkit-input-placeholder textarea::-moz-placeholder textarea::-moz-placeholder input::-ms-input-placeholder,
input::placeholder input::-webkit-input-placeholder textarea::-moz-placeholder textarea::-moz-placeholder textarea::-ms-input-placeholder,
input::placeholder textarea::-webkit-input-placeholder input::-moz-placeholder input::-moz-placeholder input::-ms-input-placeholder,
input::placeholder textarea::-webkit-input-placeholder input::-moz-placeholder input::-moz-placeholder textarea::-ms-input-placeholder,
input::placeholder textarea::-webkit-input-placeholder input::-moz-placeholder textarea::-moz-placeholder input::-ms-input-placeholder,
input::placeholder textarea::-webkit-input-placeholder input::-moz-placeholder textarea::-moz-placeholder textarea::-ms-input-placeholder,
input::placeholder textarea::-webkit-input-placeholder textarea::-moz-placeholder input::-moz-placeholder input::-ms-input-placeholder,
input::placeholder textarea::-webkit-input-placeholder textarea::-moz-placeholder input::-moz-placeholder textarea::-ms-input-placeholder,
input::placeholder textarea::-webkit-input-placeholder textarea::-moz-placeholder textarea::-moz-placeholder input::-ms-input-placeholder,
input::placeholder textarea::-webkit-input-placeholder textarea::-moz-placeholder textarea::-moz-placeholder textarea::-ms-input-placeholder,
textarea::placeholder input::-webkit-input-placeholder input::-moz-placeholder input::-moz-placeholder input::-ms-input-placeholder,
textarea::placeholder input::-webkit-input-placeholder input::-moz-placeholder input::-moz-placeholder textarea::-ms-input-placeholder,
textarea::placeholder input::-webkit-input-placeholder input::-moz-placeholder textarea::-moz-placeholder input::-ms-input-placeholder,
textarea::placeholder input::-webkit-input-placeholder input::-moz-placeholder textarea::-moz-placeholder textarea::-ms-input-placeholder,
textarea::placeholder input::-webkit-input-placeholder textarea::-moz-placeholder input::-moz-placeholder input::-ms-input-placeholder,
textarea::placeholder input::-webkit-input-placeholder textarea::-moz-placeholder input::-moz-placeholder textarea::-ms-input-placeholder,
textarea::placeholder input::-webkit-input-placeholder textarea::-moz-placeholder textarea::-moz-placeholder input::-ms-input-placeholder,
textarea::placeholder input::-webkit-input-placeholder textarea::-moz-placeholder textarea::-moz-placeholder textarea::-ms-input-placeholder,
textarea::placeholder textarea::-webkit-input-placeholder input::-moz-placeholder input::-moz-placeholder input::-ms-input-placeholder,
textarea::placeholder textarea::-webkit-input-placeholder input::-moz-placeholder input::-moz-placeholder textarea::-ms-input-placeholder,
textarea::placeholder textarea::-webkit-input-placeholder input::-moz-placeholder textarea::-moz-placeholder input::-ms-input-placeholder,
textarea::placeholder textarea::-webkit-input-placeholder input::-moz-placeholder textarea::-moz-placeholder textarea::-ms-input-placeholder,
textarea::placeholder textarea::-webkit-input-placeholder textarea::-moz-placeholder input::-moz-placeholder input::-ms-input-placeholder,
textarea::placeholder textarea::-webkit-input-placeholder textarea::-moz-placeholder input::-moz-placeholder textarea::-ms-input-placeholder,
textarea::placeholder textarea::-webkit-input-placeholder textarea::-moz-placeholder textarea::-moz-placeholder input::-ms-input-placeholder,
textarea::placeholder textarea::-webkit-input-placeholder textarea::-moz-placeholder textarea::-moz-placeholder textarea::-ms-input-placeholder {
  /* Internet Explorer 10-11  Microsoft Edge*/
  color: #454545 !important;
}
body {
  /* 定义滚动条样式 */
  /*定义滚动条轨道 内阴影*/
  /*定义滑块 内阴影*/
}
body .ant-checkbox-inner {
  background-color: #ffffff;
}
body .ant-radio-group .ant-radio-button-wrapper {
  overflow: hidden;
  border-color: #e8aa0d;
  color: #e8aa0d;
  background-color: #fffbf0;
}
body .ant-radio-group .ant-radio-button-wrapper:first-child {
  border-radius: 15px 0px 0px 15px;
}
body .ant-radio-group .ant-radio-button-wrapper:last-child {
  border-radius: 0px 15px 15px 0px;
}
body .ant-radio-group .ant-radio-button-wrapper.ant-radio-button-wrapper-checked {
  background-color: #fabf00;
  color: #454545;
}
body .ant-radio-group .ant-radio-button-wrapper:not(:first-child):before {
  background-color: #e8aa0d;
}
body::-webkit-scrollbar {
  width: 6px;
  height: 6px;
  background-color: rgba(0, 0, 0, 0.05);
}
body::-webkit-scrollbar-track {
  box-shadow: inset 0 0 0px rgba(240, 240, 240, 0.3);
  background-color: rgba(0, 0, 0, 0.05);
}
body::-webkit-scrollbar-thumb {
  border-radius: 10px;
  box-shadow: inset 0 0 0px rgba(240, 240, 240, 0.3);
  background-color: rgba(0, 0, 0, 0);
  opacity: 0;
}
body:hover::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.25);
  opacity: 1;
}
body .wd-100 {
  width: 100%;
}
body .user-name-drop-down li.ant-dropdown-menu-item {
  white-space: nowrap;
}
body .sn-select-list .ant-select .ant-select-selector {
  background-color: #f4f4f4;
}
body .dropdown-button-radius .ant-btn {
  width: 70px;
  border-top-left-radius: 32px;
  border-bottom-left-radius: 32px;
}
body .dropdown-button-radius .ant-dropdown-trigger {
  width: 70px;
  border-top-right-radius: 32px;
  border-bottom-right-radius: 32px;
}
body .dropdown-button-radius-large .ant-btn {
  width: 100px;
  border-top-left-radius: 32px;
  border-bottom-left-radius: 32px;
}
body .dropdown-button-radius-large .ant-dropdown-trigger {
  width: 70px;
  border-top-right-radius: 32px;
  border-bottom-right-radius: 32px;
}
body .span-d-wd-100 {
  display: inline-block;
  width: 100%;
}
body .primary {
  color: #e8aa0d;
}
body .br-20 {
  border-radius: 20px;
}
body .pd-10 {
  padding: 10px;
}
body .ml-7 {
  margin-left: -7.5px;
  margin-right: -7.5px;
}
body .ant-pro-page-container.container-no-bg {
  background-color: transparent;
}
body .ant-pro-page-container.container-no-bg .ant-pro-page-container-children-container {
  padding: 0px !important;
}
body .ant-pro-page-container.container-no-bg .ant-pro-page-container-children-container #installerPage {
  padding: 0px !important;
}
body .ellipsis-text {
  display: inline-block;
  width: 100%;
  text-overflow: ellipsis;
  overflow: hidden;
}
body .pd-t-12 {
  padding-top: 12px;
}
body .logo-width {
  width: 230px;
  display: flex;
  justify-content: center;
}
body .header-logo-width-zh img {
  width: 110px;
  height: 50px;
}
body .header-logo-width-en img {
  width: 125px;
  height: 70px;
}
body .ant-pro-global-header-logo-mobile {
  display: none;
}
body .ant-picker,
body .ant-select:not(.ant-select-customize-input) .ant-select-selector {
  border-radius: 5px;
}
body .suspense-spin-loading {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
body .ml-12 {
  margin-left: 12px;
}
body .fSize-16 {
  font-size: 16px;
}
body .fSize-14 {
  font-size: 14px;
}
@media screen and (max-width: 767px) {
  body .dashboard-editor-container .diagram-pic-container .single-item,
  body #clone-dom .diagram-pic-container .single-item,
  body .dashboard-editor-container .diagram-pic-container ul.diagram-data,
  body #clone-dom .diagram-pic-container ul.diagram-data {
    transform: scale(0.6);
    -ms-transform: scale(0.6);
    -moz-transform: scale(0.6);
    -webkit-transform: scale(0.6);
    -o-transform: scale(0.6);
  }
  body .dashboard-editor-container .energy-diagram .diagram-pic-container .diagram-data-generator,
  body #clone-dom .energy-diagram .diagram-pic-container .diagram-data-generator,
  body .dashboard-editor-container .diagram-pic-container .diagram-data-windpower,
  body #clone-dom .diagram-pic-container .diagram-data-windpower {
    top: -10%;
  }
  body .dashboard-editor-container .diagram-pic-container .diagram-data-windpower,
  body #clone-dom .diagram-pic-container .diagram-data-windpower {
    width: auto;
    max-width: 120px;
    word-break: normal;
  }
  body .dashboard-editor-container .energy-diagram .diagram-pic-container .diagram-data-num1,
  body #clone-dom .energy-diagram .diagram-pic-container .diagram-data-num1,
  body .dashboard-editor-container .energy-diagram .diagram-pic-container .diagram-data-num4,
  body #clone-dom .energy-diagram .diagram-pic-container .diagram-data-num4 {
    left: 12%;
  }
  body .dashboard-editor-container .energy-diagram .diagram-pic-container .diagram-data-num2,
  body #clone-dom .energy-diagram .diagram-pic-container .diagram-data-num2,
  body .dashboard-editor-container .energy-diagram .diagram-pic-container .diagram-data-num5,
  body #clone-dom .energy-diagram .diagram-pic-container .diagram-data-num5 {
    right: 12%;
  }
  body .dashboard-editor-container .energy-diagram .diagram-pic-container .diagram-data-num1,
  body #clone-dom .energy-diagram .diagram-pic-container .diagram-data-num1,
  body .dashboard-editor-container .energy-diagram .diagram-pic-container .diagram-data-num2,
  body #clone-dom .energy-diagram .diagram-pic-container .diagram-data-num2 {
    top: 35%;
  }
  body .dashboard-editor-container .energy-diagram .diagram-pic-container .diagram-data-num5,
  body #clone-dom .energy-diagram .diagram-pic-container .diagram-data-num5,
  body .dashboard-editor-container .energy-diagram .diagram-pic-container .diagram-data-num4,
  body #clone-dom .energy-diagram .diagram-pic-container .diagram-data-num4 {
    top: 75%;
  }
  body .dashboard-editor-container .energy-diagram-content svg,
  body #clone-dom .energy-diagram-content svg {
    height: 100% !important;
  }
}
body #line_chart_01 canvas:hover,
body #data-analysis-chart canvas:hover {
  cursor: default;
}
body .dashboard-editor-container .ant-picker.ant-picker-small,
body #clone-dom .ant-picker.ant-picker-small {
  border-radius: 12px;
}
body .dashboard-editor-container .ant-picker-input > input,
body #clone-dom .ant-picker-input > input {
  color: rgba(0, 0, 0, 0.28);
}
body .power_charts .ant-radio-group > label:first-child {
  border-top-left-radius: 15px;
  border-bottom-left-radius: 15px;
}
body .power_charts .ant-radio-group > label:last-child {
  border-top-right-radius: 15px;
  border-bottom-right-radius: 15px;
}
body .power_charts .ant-radio-group > .ant-radio-button-wrapper-checked {
  background-color: #fabf00;
  color: #454545;
}
body .power_charts .ant-radio-group > label {
  font-size: 12px;
}
body .ant-select-selection-search input {
  border-radius: 5px;
}
body .ant-form-item-control-input-content .ant-input-affix-wrapper {
  border-radius: 5px;
}
body .ant-picker-range {
  border-radius: 5px;
}
body .ant-form-item-control-input-content input {
  border-radius: 5px;
}
body #_resetZoom_echart_customer:hover {
  background-color: #f7f7f7;
}
body .ant-card {
  width: 100%;
}
body li {
  list-style: none;
}
body .search-condition {
  margin: 20px 0px;
}
body .search-condition .date {
  text-align: right;
}
body .pagination-container {
  width: 100%;
  text-align: right;
  margin-top: 20px;
}
body .flex {
  display: -webkit-box;
  display: -moz-flex;
  display: -ms-flexbox;
  display: flex;
}
body .profi_title {
  line-height: 60px;
  text-align: left;
  padding-left: 2%;
  font-size: 2rem;
  color: #f8d27d;
  text-shadow: 6px 3px 3px #824f4f;
}
body .profi_progress {
  line-height: 30px;
  font-size: 12px;
  margin: 3% 0 0;
  padding-right: 0.5%;
}
body .customer-card-style-index .bg-white {
  background: #fff;
  padding: 10px;
  border-radius: 20px;
}
body .customer-card-style-index .bg-white .ant-card {
  border-radius: 20px;
  background: #f5f5f5;
}
body .customer-card-style-index .bg-white .ant-card .ant-card-header {
  border-bottom: 0px;
  padding: 12px 12px 0px 12px;
}
body .customer-card-style-index .bg-white .ant-card .ant-card-body {
  padding-left: 12px;
  padding-right: 12px;
}
body .customer-card-style-index .bg-white .ant-card .ant-card-head-title {
  color: rgba(0, 0, 0, 0.45);
  font-size: 14px;
  font-weight: 600;
}
body .customer-card-style-index .bg-white .ant-card .ant-card-head-title span.title {
  margin-right: 10px;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  color: #868686;
}
body .customer-card-style-index .bg-white .ant-card .ant-card-head-title span.title.active {
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  color: #454545;
  border-bottom: 2px solid #e8aa0d;
}
body .customer-card-style-index .bg-white .ant-card .ant-card-head-title span.title.pointer {
  cursor: pointer;
}
.ant-spin-nested-loading {
  height: 100%;
}
.ant-spin-nested-loading .ant-spin-container {
  height: 100%;
}
.ant-spin-nested-loading .ant-spin-container .ant-table {
  flex: 1;
}
.ant-spin-nested-loading .ant-spin-container .ant-table .ant-table-container {
  height: 100%;
}
.ant-spin-nested-loading .ant-spin-container .ant-table .ant-table-container .ant-table-content {
  height: 100%;
}
.ant-table-thead > tr > th {
  background: #fff;
  font-weight: bold;
}
.ant-table-thead > tr > th:not(:last-child):not(.ant-table-selection-column):not(.ant-table-row-expand-icon-cell):not([colspan])::before {
  background-color: inherit !important;
}
.auto-table .ant-table-body {
  overflow: auto !important;
}
/* table高度自适应布局 */
.custom-contant {
  display: flex;
  min-height: calc(100vh - 140px);
  flex-direction: column;
  /* 普通情况下：只有查询表单 */
  /* 修改列表查询条件 */
  /* 布局里面包含tabs标签页的时候 */
}
.custom-contant .custom-table-flex {
  flex: 1;
}
.custom-contant .custom-table-flex .detail-table-flex .ant-table-content {
  min-height: 100% !important;
}
.custom-contant .custom-table-flex .ant-spin-nested-loading {
  height: 100%;
}
.custom-contant .custom-table-flex .ant-spin-nested-loading .ant-spin-container {
  display: flex;
  height: 100%;
  flex-direction: column;
}
.custom-contant .custom-table-flex .ant-spin-nested-loading .ant-spin-container .ant-table {
  flex: 1;
}
.custom-contant .custom-table-flex .ant-spin-nested-loading .ant-spin-container .ant-table .ant-table-container {
  height: 100%;
}
.custom-contant .custom-table-flex .ant-spin-nested-loading .ant-spin-container .ant-table .ant-table-container .ant-table-content {
  min-height: calc(100vh - 300px);
}
.custom-contant .custom-table-flex .ant-spin-nested-loading .ant-spin-container .ant-table-thead > tr > th {
  background: #fff;
  font-weight: bold;
}
.custom-contant .custom-table-flex .ant-spin-nested-loading .ant-spin-container .ant-table-ping-right:not(.ant-table-has-fix-right) > .ant-table-container::after,
.custom-contant .custom-table-flex .ant-spin-nested-loading .ant-spin-container .ant-table-ping-left:not(.ant-table-has-fix-left) > .ant-table-container::before {
  box-shadow: none;
}
.custom-contant .custom-table-flex .ant-spin-nested-loading .ant-spin-container .ant-table-thead > tr > th:not(:last-child):not(.ant-table-selection-column):not(.ant-table-row-expand-icon-cell):not(
            [colspan]
          )::before {
  background-color: inherit !important;
}
.custom-contant .custom-search {
  padding: 10px 0;
  margin-bottom: 10px;
}
.custom-contant .custom-search .ant-form-item {
  margin-bottom: 0px;
}
.custom-contant .custom-search .ant-form-item-label {
  padding: 8px 0;
}
.custom-contant .ant-tabs-content-holder {
  height: 100%;
}
.custom-contant .ant-tabs-content-holder .ant-tabs-content {
  height: 100%;
}
.custom-contant .ant-tabs-content-holder .ant-tabs-content .ant-tabs-tabpane-active {
  display: flex;
  height: 100%;
  flex-direction: column;
}
/* 修改左侧样式背景 */
.ant-pro-sider {
  background-color: #fff !important;
}
.ant-layout-content {
  background-color: #f5f5f5 !important;
}
.ant-pro-page-container {
  background-color: #fff;
  border-radius: 10px;
  margin: 10px;
}
.page-shadow {
  box-shadow: 0px 1px 10px rgba(0, 0, 0, 0.15);
}
.system-left-list {
  box-shadow: 0px 1px 10px rgba(0, 0, 0, 0.15) !important;
}
.system-tabs .ant-tabs-content-holder {
  box-shadow: 0px 1px 10px rgba(0, 0, 0, 0.15);
}
.ant-page-header {
  border-bottom: 1px solid #ebeef5;
}
/* 操作里面删除文字样式 */
.delete-text {
  color: red;
}
.green {
  color: #87ca16;
}
.execute-btn {
  color: #1dc7ea;
  font-size: 14px;
}
.execute-btn:hover {
  cursor: pointer;
}
.execute-btn.is-disabled {
  color: #c0c4cc;
  cursor: not-allowed;
  background-image: none;
}
.detail-btn {
  color: #87ca16 !important;
  display: inline-block;
  margin-right: 10px;
  font-size: 14px;
}
.detail-btn:hover {
  cursor: pointer;
}
/* 表单项垂直布局时，按钮位置下移 */
.move-down-button {
  margin-top: 30px;
}
/* 修改手风琴样式 */
.custom-collapse {
  background-color: transparent !important;
}
.custom-collapse .ant-collapse-item {
  border-bottom: 1px solid #ebeef5 !important;
}
.custom-collapse .ant-collapse-item:last-child {
  border-bottom: 0px !important;
}
.updateLog-collapse .ant-collapse-expand-icon::before {
  content: '*';
  color: red;
  margin-right: 4px;
}
/* 表单设置一行展示 */
.custom-inline .ant-form-item-row {
  flex-direction: inherit !important;
}
.custom-inline .ant-form-item-control {
  width: auto !important;
  margin: -4px 0 0 8px;
}
.custom-form-item .custom-tooltip {
  margin-left: 10px;
  vertical-align: middle;
}
.custom-form-item .custom-tooltip .anticon-info-circle {
  margin-left: 5px;
  color: rgba(0, 0, 0, 0.45);
}
/* 设置右侧内容区域填充 */
.ant-pro-page-container-children-content {
  padding-inline: 10px;
}
/* 全局设置公共样式 */
.mr10 {
  margin-right: 10px;
}
.ml8 {
  margin-left: 8px;
}
.mt10 {
  margin-top: 10px;
}
.mb10 {
  margin-bottom: 10px;
}
.ml50 {
  margin-left: 50px;
}
.input-number-width {
  width: 100% !important;
}
.input-number-small {
  display: inline-block;
}
.input-number-small .ant-input-number {
  width: 100% !important;
}
.input-number-big {
  display: inline-block;
  width: 75%;
}
.current-setting {
  display: inline-block;
}
.in-line-style .padding-tope-style {
  padding-top: 10px;
}
.red-star {
  color: #ff4d4f;
}
/* 自定义form表单下按钮靠右对齐 */
.custom-form-btn {
  margin: 20px -24px 0 -24px;
  padding: 10px 24px 0 24px;
  text-align: right;
  border-top: 1px solid #f0f0f0;
}
.custom-form-btn .ant-btn-default {
  margin-right: 8px;
}
.m-b-xs {
  margin-bottom: 8px !important;
}
.has-file-upload .ant-form-item-control {
  position: relative;
}
.has-file-upload .ant-form-item-control .vir-btn {
  position: absolute;
  left: 4px;
  top: 8px;
  height: 28px;
  line-height: 28px;
  min-width: 80px;
  z-index: 3;
  text-align: center;
  border: 1px solid #ccc;
  background-color: #f8f8f8;
  padding: 0px 6px;
}
.has-file-upload .ant-form-item-control input {
  position: absolute;
  left: 0px;
  top: 0px;
  height: 28px;
  line-height: 28px;
  width: 80px;
  z-index: 10;
  opacity: 0;
}
.has-file-upload .ant-form-item-control span {
  display: inline-block;
  margin-left: 90px;
}
/* 自定义form表单边框 */
.custom-border {
  padding: 15px 25px;
  border: 1px solid #ccc;
}
.custom-btn {
  text-align: right;
  margin-top: 20px;
}
.custom-btn .ant-btn {
  margin-right: 12px;
}
/* 自定义研发数据调试调试数据一行显示五个 */
.custom-research-data {
  padding: 10px 5px;
}
.custom-research-data .ant-col-4 {
  max-width: 20%;
  flex: 0 0 20%;
}
.custom-research-data .ant-col-4 p:first-child {
  margin-bottom: 4px;
}
/* 自定义数据报表生成状况 */
.report-day {
  width: 100%;
}
.report-day ul {
  padding-inline-start: 0px;
  padding: 4px 10px;
}
.report-day li {
  list-style: none;
  width: 10%;
  display: inline-block;
  border-bottom: 1px solid #e4e7ed;
  padding: 8px 10px 0 10px;
  height: 66px;
  vertical-align: top;
}
.report-day li .ant-btn {
  text-align: left;
  padding: 0px;
}
.report-day .report-day-bg {
  background: #dff0d8;
}
.report-day .report-day-bg .report-day-regenerate {
  color: #ff4a55;
}
.report-day .report-day-generate {
  color: #1dc7ea;
}
.report-status {
  border: 1px solid #f0f0f0;
  border-radius: 10px;
  padding: 10px 0;
}
.report-status .title {
  font-weight: bold;
  border-bottom: 1px solid #f0f0f0;
  padding: 0 10px 10px;
}
.report-status .ant-form,
.report-status .ant-table-wrapper {
  padding: 0 10px;
}
.report-table .ant-table-tbody > tr > td[title='N'] {
  background: #f2dede !important;
}
.report-table .ant-table-tbody > tr > td[title='N']:hover {
  background: #ebcccc !important;
}
.report-table .ant-table-tbody > tr > td[title='Y'] {
  background: #dff0d8 !important;
}
.report-table .ant-table-tbody > tr > td[title='Y']:hover {
  background: #d0e9c6 !important;
}
.report-table .ant-table-tbody > tr > td:first-child {
  background: none;
}
.report-table .ant-table-tbody > tr > td:first-child:hover {
  background: none;
}
/* 公共样式 */
.text-right {
  text-align: right;
}
.text-center {
  text-align: center;
}
.common-radius {
  border-radius: 30px;
  padding: 2px 14px;
}
.ant-tooltip {
  max-width: 670px;
}
.ant-tooltip img {
  max-width: 640px;
}
/* 左侧菜单选中时样式 */
.ant-layout-sider .ant-menu-item-selected,
.ant-layout-sider .ant-menu-submenu .ant-menu-item-selected,
.ant-menu-item:active,
.ant-menu-submenu-title:active {
  background-color: #f5f5f5 !important;
  color: rgba(0, 0, 0, 0.8) !important;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat;
  background-size: 4px 100%;
  font-weight: bold;
}
.ant-layout-sider .ant-menu-light .ant-menu-submenu-title:hover,
.ant-menu-submenu:hover > .ant-menu-submenu-title > .ant-menu-submenu-arrow {
  color: rgba(0, 0, 0, 0.8) !important;
}
.ant-layout-sider-children {
  height: 92% !important;
  padding-inline: 0px !important;
  border-inline-end: 0px !important;
}
.ant-menu-sub.ant-menu-inline {
  background: #ffffff;
}
.ant-menu-title-content a {
  color: rgba(0, 0, 0, 0.85) !important;
}
.ant-menu-submenu-selected {
  color: rgba(0, 0, 0, 0.8) !important;
}
.ant-menu-vertical .ant-menu-item::after,
.ant-menu-vertical-left .ant-menu-item::after,
.ant-menu-vertical-right .ant-menu-item::after,
.ant-menu-inline .ant-menu-item::after {
  border: 0px !important;
}
.ant-menu-sub {
  padding-inline-start: 0px !important;
}
.ant-layout-sider-children > :first-child {
  overflow: hidden !important;
}
.ant-layout-sider-children > :first-child:hover {
  overflow: hidden auto !important;
}
.ant-layout-sider-children > :first-child::-webkit-scrollbar {
  width: 6px;
  border-radius: 4px;
  background-color: rgba(0, 0, 0, 0.05);
}
.ant-layout-sider-children > :first-child::-webkit-scrollbar-thumb {
  width: 10px;
  border-radius: 10px;
  background-color: rgba(0, 0, 0, 0.25);
}
.ant-pro-layout .ant-pro-sider.ant-pro-sider-fixed-mix {
  height: 100% !important;
}
.language-zh .ant-menu-submenu-arrow {
  left: 190px;
}
.ant-layout-sider-collapsed .ant-menu-submenu,
.ant-layout-sider-collapsed .ant-menu-item {
  width: 20px;
  margin: 0 auto;
  overflow: hidden;
  background-color: none !important;
  background: none !important;
}
.ant-menu-submenu-selected .ant-menu-submenu-title {
  background: none !important;
}
.language-en .ant-menu-submenu-arrow {
  left: 230px;
}
.ant-menu-submenu:hover,
.ant-menu-item a:hover {
  color: rgba(0, 0, 0, 0.8) !important;
}
/* 自定义Modal全屏样式 */
.common-full {
  padding: 20px;
}
.common-full,
.common-exit {
  position: inherit !important;
  background: #fff;
}
.common-full .common-full-screen,
.common-exit .common-full-screen {
  cursor: pointer;
  position: absolute;
  top: 22px;
  right: 55px;
  z-index: 999;
}
.ant-layout-header {
  border-bottom-right-radius: 15px !important;
}
/* 顶部导航，左侧菜单圆角样式 */
.ant-layout-sider,
.ant-pro-layout .ant-layout-header.ant-pro-layout-header-fixed-header {
  border-bottom-right-radius: 15px;
}
.common-ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
/* 定义滚动条样式 */
::-webkit-scrollbar {
  width: 6px !important;
  height: 6px !important;
  background-color: rgba(0, 0, 0, 0.05) !important;
}
/*定义滚动条轨道 内阴影*/
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 0px rgba(240, 240, 240, 0.3) !important;
  background-color: rgba(0, 0, 0, 0.05) !important;
}
/*定义滑块 内阴影*/
::-webkit-scrollbar-thumb {
  border-radius: 10px !important;
  box-shadow: inset 0 0 0px rgba(240, 240, 240, 0.3) !important;
  background-color: rgba(0, 0, 0, 0) !important;
  opacity: 0 !important;
}
:hover::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.25) !important;
  opacity: 1 !important;
}
.common-procard .ant-pro-card-body {
  padding-inline: inherit !important;
}
.ant-pro-field-index-column-border {
  background-color: inherit !important;
  color: #000;
  font-size: 14px;
}
/* 系统右侧内容区域 */
.ant-pro-layout .ant-pro-layout-content {
  padding-block: 4px;
  padding-inline: 10px;
}
/* 统一修改日期控件颜色 */
.ant-picker-input > input {
  color: rgba(0, 0, 0, 0.85) !important;
}
/* 首页更新通知 */
.notice-box {
  font-family: 'PingFang SC';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  white-space: pre-line;
}
.notice-yellow {
  color: #fabf00;
  border-bottom: 2px solid #fabf00;
  padding-bottom: 2px;
  cursor: pointer;
}
.checkbox-checked-color-change .ant-checkbox-wrapper-checked {
  color: #facb00 !important;
}
.light-green {
  color: #87ca16 !important;
}
.ant-picker-input > input[disabled] {
  color: rgba(0, 0, 0, 0.25) !important;
}
#clone-dom {
  overflow-y: auto;
  height: 100%;
  width: 100%;
  overflow-x: hidden;
  padding-top: 10px;
}
.ant-modal-content {
  border-radius: 4px;
}
.ant-modal-content .ant-modal-body {
  padding: 15px 10px 10px;
}
.ant-modal-content .ant-modal-body .ant-modal-confirm-body-wrapper .ant-btn-default {
  height: 32px;
  padding: 4px 16px;
  font-size: 14px;
  border-radius: 32px;
}
.ant-modal-content .ant-modal-body .ant-modal-confirm-body-wrapper .ant-btn-primary {
  height: 32px;
  padding: 4px 16px;
  font-size: 14px;
  border-radius: 32px;
}
.energy-title {
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  color: #2e2e2e;
}
.ant-page-header {
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}
.system-message-radio {
  overflow: hidden;
}
#energy-diagram .ant-picker {
  border-radius: 20px;
}
/* antd confirm弹窗去掉取消按钮的样式 */
.ant-modal-confirm-btns-delete .ant-modal-confirm-btns .ant-btn-default {
  display: none;
}
`, "",{"version":3,"sources":["webpack://./src/styles/variables.less","webpack://./src/resetAnt.less"],"names":[],"mappings":"AAWA,mCAAA;AAoDA;EACE,4BAAA;EACA,oBAAA;EAEA,eAAA;EACA,8BAAA;EACA,kBAAA;EACA,iCAAA;EACA,mBAAA;AC9DF;AARA;EACE,eAAA;AAUF;AAXA;EAGI,yBAAA;AAWJ;AARA;EACE,kCAAA;EACA,kBAAA;AAUF;AAPA;EACE,eAAA;AASF;AANA;EACE,oCAAA;AAQF;AALA;EACE,eAAA;AAOF;AAJA;;;EAGE,YAAA;EACA,0CAAA;AAMF;AAVA;;;EAMI,WAAA;AASJ;AAfA;;;EASI,aAAA;EACA,eAAA;EACA,gBAAA;AAWJ;AAPA;EACE,SAAA;EACA,UAAA;AASF;AAXA;EAII,qBAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;EACA,+BAAA;EACA,cAAA;EACA,YAAA;AAUJ;AApBA;EAcM,kBAAA;AASN;AAvBA;EAmBM,sBAAA;AAON;AALI;EAEI,gBAAA;AAMR;AA7BA;EA2BM,uBAAA;EACA,gBAAA;AAKN;AAJM;EACE,aAAA;AAMR;AApCA;EAmCI,yBAAA;EACA,sBAAA;EACA,oBAAA;EACA,qBAAA;AAIJ;AA1CA;EAyCI,iBAAA;AAIJ;AA7CA;EA6CI,oBAAA;EAGF,2CAA2C;EADzC,iBAAA;EAGF,gBAAgB;EADd,qBAAA;EAGF,wDAAwD;EADtD,kBAAA;EAGF,gBAAgB;EADd,oBAAA;EAGF,UAAU;EADR,aAAA;AAGJ;AA1DA;EA2DM,YAAA;EACA,gBAAA;AAEN;AA9DA;EA8DQ,4BAAA;EACA,2BAAA;EACA,sBAAA;EACA,uBAAA;AAGR;AADM;EACE,gBAAA;EACA,uBAAA;AAGR;AAGA;EACE,8BAAA;AADF;AAME;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EA2BA,2CAA2C;EAlBzC,yBAAA;AAoBJ;AAhBA;EAkBE,YAAY;EACZ,cAAc;EACd,WAAW;AACb;AArBA;EAEI,yBAAA;AAsBJ;AAxBA;EAMM,gBAAA;EAUA,qBAAA;EACA,cAAA;EACA,yBAAA;AAYN;AAtBM;EACE,gCAAA;AAwBR;AArBM;EACE,gCAAA;AAuBR;AAhBM;EACE,yBAAA;EACA,cAAA;AAkBR;AAfM;EACE,yBAAA;AAiBR;AAZE;EACE,UAAA;EACA,WAAA;EACA,qCAAA;AAcJ;AAVE;EACE,kDAAA;EACA,qCAAA;AAYJ;AARE;EACE,mBAAA;EACA,kDAAA;EACA,kCAAA;EACA,UAAA;AAUJ;AAPE;EACE,qCAAA;EACA,UAAA;AASJ;AA9DA;EA8DI,WAAA;AAGJ;AAjEA;EAmEM,mBAAA;AACN;AApEA;EA0EQ,yBAAA;AAHR;AAvEA;EAiFM,WAAA;EACA,4BAAA;EACA,+BAAA;AAPN;AA5EA;EAuFM,WAAA;EACA,6BAAA;EACA,gCAAA;AARN;AAjFA;EA+FM,YAAA;EACA,4BAAA;EACA,+BAAA;AAXN;AAtFA;EAqGM,WAAA;EACA,6BAAA;EACA,gCAAA;AAZN;AA3FA;EA4GI,qBAAA;EACA,WAAA;AAdJ;AA/FA;EAiHI,cAAA;AAfJ;AAlGA;EAqHI,mBAAA;AAhBJ;AArGA;EAyHI,aAAA;AAjBJ;AAxGA;EA6HI,mBAAA;EACA,oBAAA;AAlBJ;AA5GA;EAkII,6BAAA;AAnBJ;AA/GA;EAqIM,uBAAA;AAnBN;AAlHA;EAwIQ,uBAAA;AAnBR;AArHA;EA8II,qBAAA;EACA,WAAA;EACA,uBAAA;EACA,gBAAA;AAtBJ;AA3HA;EAqJI,iBAAA;AAvBJ;AA9HA;EAyJI,YAAA;EACA,aAAA;EACA,uBAAA;AAxBJ;AAnIA;EAgKM,YAAA;EACA,YAAA;AA1BN;AAvIA;EAuKM,YAAA;EACA,YAAA;AA7BN;AA3IA;EA6KI,aAAA;AA/BJ;AA9IA;;EAkLI,kBAAA;AAhCJ;AAlJA;EAsLI,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;AAjCJ;AAxJA;EA6LI,iBAAA;AAlCJ;AA3JA;EAiMI,eAAA;AAnCJ;AA9JA;EAqMI,eAAA;AApCJ;AAuCE;EAAA;;;;IAKM,qBAAA;IACA,yBAAA;IACA,0BAAA;IACA,6BAAA;IACA,wBAAA;EArCN;EA4BA;;;;IAcM,SAAA;EApCN;EAsBA;;IAkBM,WAAA;IACA,gBAAA;IACA,kBAAA;EApCN;EAgBA;;;;IA2BU,SAAA;EArCV;EAUA;;;;IAgCU,UAAA;EApCV;EAIA;;;;IAqCU,QAAA;EAnCV;EAFA;;;;IA0CU,QAAA;EAlCV;EARA;;IAiDQ,uBAAA;EArCR;AACF;AArNA;;EAkQM,eAAA;AAzCN;AAzNA;;EAyQM,mBAAA;AA5CN;AA7NA;;EA6QM,0BAAA;AA5CN;AAkDM;EACE,4BAAA;EACA,+BAAA;AAhDR;AAmDM;EACE,6BAAA;EACA,gCAAA;AAjDR;AAoDM;EACE,yBAAA;EACA,cAAA;AAlDR;AAqDM;EACE,eAAA;AAnDR;AAhPA;EA0SM,kBAAA;AAvDN;AAnPA;EAgTM,kBAAA;AA1DN;AAtPA;EAqTI,kBAAA;AA5DJ;AAzPA;EA0TM,kBAAA;AA9DN;AAmEI;EACE,yBAAA;AAjEN;AA/PA;EAqUI,WAAA;AAnEJ;AAlQA;EAyUI,gBAAA;AApEJ;AArQA;EA6UI,gBAAA;AArEJ;AAxQA;EAgVM,iBAAA;AArEN;AA3QA;EAqVI,WAAA;EACA,iBAAA;EACA,gBAAA;AAvEJ;AAhRA;EA2VI,oBAAA;EACA,kBAAA;EACA,oBAAA;EACA,aAAA;AAxEJ;AAtRA;EAkWI,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,gCAAA;AAzEJ;AA9RA;EA2WI,iBAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;AA1EJ;AApSA;EAmXM,gBAAA;EACA,aAAA;EACA,mBAAA;AA5EN;AAzSA;EAyXQ,mBAAA;EACA,mBAAA;AA7ER;AA7SA;EA6XU,kBAAA;EACA,2BAAA;AA7EV;AAjTA;EAkYU,kBAAA;EACA,mBAAA;AA9EV;AArTA;EAuYU,0BAAA;EACA,eAAA;EACA,gBAAA;AA/EV;AA1TA;EA6YY,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;AAhFZ;AAkFY;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,gCAAA;AAhFd;AAmFY;EACE,eAAA;AAjFd;AA0FA;EACE,YAAA;AAxFF;AAuFA;EAKI,YAAA;AAzFJ;AAoFA;EASM,OAAA;AA1FN;AAiFA;EAYQ,YAAA;AA1FR;AA8EA;EAeU,YAAA;AA1FV;AAiGA;EACE,gBAAA;EACA,iBAAA;AA/FF;AAkGA;EAGE,oCAAA;AAlGF;AAqGA;EACE,yBAAA;AAnGF;AACA,iBAAiB;AAqGjB;EACE,aAAA;EACA,+BAAA;EACA,sBAAA;EAnGA,iBAAiB;EACjB,aAAa;EACb,qBAAqB;AACvB;AA6FA;EAMI,OAAA;AAhGJ;AA0FA;EAUQ,2BAAA;AAjGR;AAuFA;EAcM,YAAA;AAlGN;AAoFA;EAiBQ,aAAA;EACA,YAAA;EACA,sBAAA;AAlGR;AA+EA;EAsBU,OAAA;AAlGV;AA4EA;EAyBY,YAAA;AAlGZ;AAyEA;EAiCc,+BAAA;AAvGd;AAsEA;EAuCU,gBAAA;EACA,iBAAA;AA1GV;AAkEA;;EA6CU,gBAAA;AA3GV;AA8DA;;;EAqDU,oCAAA;AA9GV;AAyDA;EA6DI,eAAA;EACA,mBAAA;AAnHJ;AAqDA;EAiEM,kBAAA;AAnHN;AAkDA;EAoEM,cAAA;AAnHN;AA+CA;EA0EI,YAAA;AAtHJ;AA4CA;EA6EM,YAAA;AAtHN;AAyCA;EAgFQ,aAAA;EACA,YAAA;EACA,sBAAA;AAtHR;AACA,aAAa;AA4Hb;EACE,iCAAA;AA1HF;AA6HA;EACE,oCAAA;AA3HF;AA+HA;EACE,sBAAA;EACA,mBAAA;EACA,YAAA;AA7HF;AAiIA;EACE,4CAAA;AA/HF;AAkIA;EACE,uDAAA;AAhIF;AAuIA;EAEI,4CAAA;AAtIJ;AA0IA;EACE,gCAAA;AAxIF;AACA,eAAe;AA2If;EACE,UAAA;AAzIF;AA4IA;EACE,cAAA;AA1IF;AA6IA;EACE,cAAA;EAMA,eAAA;AAhJF;AA4IE;EACE,eAAA;AA1IJ;AA+IE;EACE,cAAA;EACA,mBAAA;EACA,sBAAA;AA7IJ;AAiJA;EACE,yBAAA;EACA,qBAAA;EACA,kBAAA;EAMA,eAAA;AApJF;AAgJE;EACE,eAAA;AA9IJ;AACA,oBAAoB;AAoJpB;EACE,gBAAA;AAlJF;AACA,YAAY;AAqJZ;EACE,wCAAA;AAnJF;AAkJA;EAII,2CAAA;AAnJJ;AA+IA;EAQI,6BAAA;AApJJ;AAwJA;EAEI,YAAA;EACA,UAAA;EACA,iBAAA;AAvJJ;AACA,aAAa;AA2Jb;EAEI,kCAAA;AA1JJ;AAwJA;EAMI,sBAAA;EACA,oBAAA;AA3JJ;AA+JA;EAMI,iBAAA;EACA,sBAAA;AAlKJ;AA2JA;EAUM,gBAAA;EACA,0BAAA;AAlKN;AACA,eAAe;AAuKf;EACE,oBAAA;AArKF;AACA,aAAa;AAwKb;EACE,kBAAA;AAtKF;AAyKA;EACE,gBAAA;AAvKF;AA0KA;EACE,gBAAA;AAxKF;AA2KA;EACE,mBAAA;AAzKF;AA4KA;EACE,iBAAA;AA1KF;AA6KA;EACE,sBAAA;AA3KF;AA8KA;EACE,qBAAA;AA5KF;AA2KA;EAII,sBAAA;AA5KJ;AAiLA;EACE,qBAAA;EACA,UAAA;AA/KF;AAkLA;EACE,qBAAA;AAhLF;AAmLA;EAEI,iBAAA;AAlLJ;AAqLA;EACE,cAAA;AAnLF;AACA,qBAAqB;AAqLrB;EACE,0BAAA;EACA,yBAAA;EACA,iBAAA;EACA,6BAAA;AAnLF;AA+KA;EAOI,iBAAA;AAnLJ;AAuLA;EACE,6BAAA;AArLF;AAwLA;EAEI,kBAAA;AAvLJ;AAqLA;EAKM,kBAAA;EACA,SAAA;EACA,QAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;EACA,UAAA;EACA,kBAAA;EACA,sBAAA;EACA,yBAAA;EACA,gBAAA;AAvLN;AAwKA;EAmBM,kBAAA;EACA,SAAA;EACA,QAAA;EACA,YAAA;EACA,iBAAA;EACA,WAAA;EACA,WAAA;EACA,UAAA;AAxLN;AA8JA;EA8BM,qBAAA;EACA,iBAAA;AAzLN;AACA,gBAAgB;AA8LhB;EACE,kBAAA;EACA,sBAAA;AA5LF;AA+LA;EACE,iBAAA;EACA,gBAAA;AA7LF;AA2LA;EAKI,kBAAA;AA7LJ;AACA,wBAAwB;AAiMxB;EACE,iBAAA;AA/LF;AA8LA;EAII,cAAA;EACA,aAAA;AA/LJ;AA0LA;EAQM,kBAAA;AA/LN;AACA,gBAAgB;AAoMhB;EACE,WAAA;AAlMF;AAiMA;EAII,yBAAA;EACA,iBAAA;AAlMJ;AA6LA;EASI,gBAAA;EACA,UAAA;EACA,qBAAA;EACA,gCAAA;EACA,wBAAA;EACA,YAAA;EACA,mBAAA;AAnMJ;AAoLA;EAkBM,gBAAA;EACA,YAAA;AAnMN;AAgLA;EAwBI,mBAAA;AArMJ;AA6KA;EA2BM,cAAA;AArMN;AA0KA;EAgCI,cAAA;AAvMJ;AA2MA;EACE,yBAAA;EACA,mBAAA;EACA,eAAA;AAzMF;AAsMA;EAMI,iBAAA;EACA,gCAAA;EACA,oBAAA;AAzMJ;AAiMA;;EAaI,eAAA;AA1MJ;AA8MA;EAEI,8BAAA;AA7MJ;AA+MI;EACE,8BAAA;AA7MN;AAwMA;EAUI,8BAAA;AA/MJ;AAiNI;EACE,8BAAA;AA/MN;AAkMA;EAkBI,gBAAA;AAjNJ;AAmNI;EACE,gBAAA;AAjNN;AACA,SAAS;AAsNT;EACE,iBAAA;AApNF;AAuNA;EACE,kBAAA;AArNF;AAwNA;EACE,mBAAA;EACA,iBAAA;AAtNF;AAyNA;EACE,gBAAA;AAvNF;AAsNA;EAII,gBAAA;AAvNJ;AACA,cAAc;AA2Nd;;;;EAIE,oCAAA;EACA,oCAAA;EACA,6DAAA;EACA,yBAAA;EACA,iBAAA;AAzNF;AA4NA;;EAEE,oCAAA;AA1NF;AA6NA;EACE,sBAAA;EACA,8BAAA;EACA,iCAAA;AA3NF;AA8NA;EACE,mBAAA;AA5NF;AA+NA;EACE,qCAAA;AA7NF;AAgOA;EACE,oCAAA;AA9NF;AAiOA;;;;EAIE,sBAAA;AA/NF;AAkOA;EACE,oCAAA;AAhOF;AAuOA;EACE,2BAAA;AArOF;AAwOA;EACE,gCAAA;AAtOF;AAyOA;EACE,UAAA;EACA,kBAAA;EACA,qCAAA;AAvOF;AA0OA;EACE,WAAA;EACA,mBAAA;EACA,qCAAA;AAxOF;AA4OA;EAEI,uBAAA;AA3OJ;AA+OA;EAEI,WAAA;AA9OJ;AAkPA;;EAGI,WAAA;EACA,cAAA;EACA,gBAAA;EACA,iCAAA;EACA,2BAAA;AAjPJ;AAqPA;EAEI,2BAAA;AApPJ;AAwPA;EAEI,WAAA;AAvPJ;AA+PA;;EAEE,oCAAA;AA7PF;AACA,iBAAiB;AAyQjB;EACE,aAAA;AAvQF;AA0QA;;EAEE,4BAAA;EACA,gBAAA;AAxQF;AAqQA;;EAMI,eAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;AAvQJ;AA2QA;EACE,2CAAA;AAzQF;AACA,kBAAkB;AA6QlB;;EAEE,gCAAA;AA3QF;AA8QA;EACE,mBAAA;EACA,gBAAA;EACA,uBAAA;AA5QF;AACA,YAAY;AA+QZ;EACE,qBAAA;EACA,sBAAA;EACA,gDAAA;AA7QF;AACA,cAAc;AAgRd;EACE,6DAAA;EACA,gDAAA;AA9QF;AACA,WAAW;AAiRX;EACE,8BAAA;EACA,6DAAA;EACA,6CAAA;EACA,qBAAA;AA/QF;AAkRA;EACE,gDAAA;EACA,qBAAA;AAhRF;AAmRA;EAEI,kCAAA;AAlRJ;AAsRA;EACE,oCAAA;EACA,WAAA;EACA,eAAA;AApRF;AACA,aAAa;AAuRb;EACE,kBAAA;EACA,oBAAA;AArRF;AACA,eAAe;AAwRf;EACE,qCAAA;AAtRF;AACA,WAAW;AAyRX;EACE,0BAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,qBAAA;AAvRF;AA0RA;EACE,cAAA;EACA,gCAAA;EACA,mBAAA;EACA,eAAA;AAxRF;AA2RA;EAEI,yBAAA;AA1RJ;AA8RA;EACE,yBAAA;AA5RF;AA+RA;EACE,qCAAA;AA7RF;AAiSA;EACE,gBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,iBAAA;AA/RF;AAkSA;EACE,kBAAA;AAhSF;AA+RA;EAII,uBAAA;AAhSJ;AA4RA;EAQQ,YAAA;EACA,iBAAA;EACA,eAAA;EACA,mBAAA;AAjSR;AAsRA;EAeQ,YAAA;EACA,iBAAA;EACA,eAAA;EACA,mBAAA;AAlSR;AAwSA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;AAtSF;AAySA;EACE,4BAAA;EACA,6BAAA;AAvSF;AA0SA;EACE,gBAAA;AAxSF;AA2SA;EAEI,mBAAA;AA1SJ;AACA,4BAA4B;AA8S5B;EAGM,aAAA;AA9SN","sourcesContent":["// 基本颜色\n@primary: #e8aa0d; // 主题黄\n@primary-black: #454545;\n@blue: #324157;\n@light-blue: #3a71a8;\n@red: #c03639;\n@pink: #e65d6e;\n@green: #30b08f;\n@tiffany: #4ab7bd;\n@yellow: #fec171;\n@panGreen: #30b08f;\n@offlinecolor:rgba (0, 0, 0, 0.25);\n@normalColor: #64d28a;\n@faultColor: #fc6f6f;\n@protectionColor: #ff8c2d;\n//新创建\n@grayBg: #b8b8b8;\n//处理中\n@darkBlue: #337ab7;\n//归档完成\n@lightGreen: #5cb85c;\n//\n//a:hover\n@aHoverColor: #87ca16;\n//btn\n@hoverBgBtnColor: #286090;\n@hoverBorderBtnColor: #204d74;\n@bgBtnColor: #337ab7;\n@borderBtnColor: #2e6da4;\n@mainSizeColor: #313131;\n@percentTen: 10%;\n@percentTwenty: 20%;\n@percentThirty: 30%;\n@percentForty: 40%;\n@percentFifty: 50%;\n@percentSixty: 60%;\n@percentSeventy: 70%;\n//sidebar\n@menuText: rgba(0, 0, 0, 0.5);\n@menuActiveText: #fff;\n// @subMenuActiveText: rgba(\n//   0,\n//   0,\n//   0,\n//   0.8\n// ); //https://github.com/ElemeFE/element/issues/12951\n@menuBg: #ffffff;\n@menuHover: rgba(0, 0, 0, 0.05);\n@subMenuBg: #ffffff;\n@subMenuHover: rgba(0, 0, 0, 0.05);\n@sideBarWidth: 200px;\n@sideBarWidth_DE: 320px;\n@sideBarWidth_IT: 320px;\n@sideBarWidth_EN: 320px;\n@sideBarWidth_JA: 320px;\n@sideBarWidth_NL: 320px;\n//自定义样式\n@borderRadiusBtn_22: 22px;\n//el-card\n@elCardBg: #f5f5f5;\n// the :export directive is the magic sauce for webpack\n// https://www.bluematador.com/blog/how-to-share-variables-between-js-and-sass\n\n:export {\n  menuText: @menuText;\n  menuActiveText: @menuActiveText;\n  // subMenuActiveText: @subMenuActiveText;\n  menuBg: @menuBg;\n  menuHover: @menuHover;\n  subMenuBg: @subMenuBg;\n  subMenuHover: @subMenuHover;\n  sideBarWidth: @sideBarWidth;\n}\n","@import '@/styles/variables.less';\n.reset-style.ant-tooltip {\n  max-width: 60vh;\n  .ant-tooltip-inner {\n    color: #000000 !important;\n  }\n}\n:root {\n  --home-baidu-map-bg-color: #ffffff;\n  --primary: @primary;\n}\n\nbody :global {\n  font-size: 12px;\n}\n\n.ant-radio-inner {\n  background-color: #ffffff !important;\n}\n\n.ant-breadcrumb-link {\n  font-size: 16px;\n}\n\n#root,\nbody,\nhtml {\n  height: 100%;\n  background: var(--home-baidu-map-bg-color);\n  .width-100-percent {\n    width: 100%;\n  }\n  .energy-diagram-text-value {\n    fill: rgba(69, 69, 69, 1);\n    font-size: 16px;\n    font-weight: 500;\n  }\n}\n\nbody * {\n  margin: 0;\n  padding: 0;\n  .cus-red-star {\n    display: inline-block;\n    margin-right: 4px;\n    color: #ff4d4f;\n    font-size: 14px;\n    font-family: SimSun, sans-serif;\n    line-height: 1;\n    content: '*';\n  }\n  .ant-form-item-mb-8 {\n    .ant-form-item {\n      margin-bottom: 8px;\n    }\n  }\n  .alpha-cloud-SSO {\n    .ant-page-header-no-children {\n      height: 0px !important;\n    }\n    &.ant-pro-layout {\n      .ant-pro-layout-bg-list {\n        background: #fff;\n      }\n    }\n    .ant-pro-page-container-children-container {\n      padding: 0px !important;\n      overflow: hidden;\n      &::-webkit-scrollbar {\n        display: none;\n      }\n    }\n  }\n  .unselect-word {\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -o-user-select: none;\n    -ms-user-select: none;\n  }\n  .ant-breadcrumb-link {\n    font-weight: bold;\n  }\n\n  .flex {\n    display: -webkit-box;\n    /* Chrome 4+, Safari 3.1, iOS Safari 3.2+ */\n    display: -moz-box;\n    /* Firefox 17- */\n    display: -webkit-flex;\n    /* Chrome 21+, Safari 6.1+, iOS Safari 7+, Opera 15/16 */\n    display: -moz-flex;\n    /* Firefox 18+ */\n    display: -ms-flexbox;\n    /* IE 10 */\n    display: flex;\n  }\n  .ant-table-cell-ellipsis {\n    .content-html.dg-html:not(ant-tooltip-open) {\n      height: 15px;\n      overflow: hidden;\n      * {\n        font-size: 12.5px !important;\n        line-height: 1.2 !important;\n        margin: 0px !important;\n        padding: 0px !important;\n      }\n      & > :first-child {\n        overflow: hidden;\n        text-overflow: ellipsis;\n      }\n    }\n  }\n}\n\n#nprogress .bar {\n  background: @primary !important; //自定义颜色\n}\n\ninput,\ntextarea {\n  &::placeholder &::-webkit-input-placeholder\n  /* WebKit, Blink, Edge */\n  &::-moz-placeholder\n  /* Mozilla Firefox 4 to 18 */\n  &::-moz-placeholder\n\n  /* Mozilla Firefox 19+ */\n  &::-ms-input-placeholder {\n    /* Internet Explorer 10-11  Microsoft Edge*/\n    color: #454545 !important;\n  }\n}\n\nbody {\n  .ant-checkbox-inner {\n    background-color: #ffffff;\n  }\n  .ant-radio-group {\n    .ant-radio-button-wrapper {\n      overflow: hidden;\n\n      &:first-child {\n        border-radius: 15px 0px 0px 15px;\n      }\n\n      &:last-child {\n        border-radius: 0px 15px 15px 0px;\n      }\n\n      border-color: @primary;\n      color: @primary;\n      background-color: #fffbf0;\n\n      &.ant-radio-button-wrapper-checked {\n        background-color: #fabf00;\n        color: @primary-black;\n      }\n\n      &:not(:first-child):before {\n        background-color: @primary;\n      }\n    }\n  }\n  /* 定义滚动条样式 */\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    background-color: rgba(0, 0, 0, 0.05);\n  }\n\n  /*定义滚动条轨道 内阴影*/\n  &::-webkit-scrollbar-track {\n    box-shadow: inset 0 0 0px rgba(240, 240, 240, 0.3);\n    background-color: rgba(0, 0, 0, 0.05);\n  }\n\n  /*定义滑块 内阴影*/\n  &::-webkit-scrollbar-thumb {\n    border-radius: 10px;\n    box-shadow: inset 0 0 0px rgba(240, 240, 240, 0.3);\n    background-color: rgba(0, 0, 0, 0);\n    opacity: 0;\n  }\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgba(0, 0, 0, 0.25);\n    opacity: 1;\n  }\n\n  // .ant-radio-group {\n  //   white-space: nowrap;\n  //   overflow-x: auto;\n  // }\n\n  .wd-100 {\n    width: 100%;\n  }\n\n  .user-name-drop-down {\n    li.ant-dropdown-menu-item {\n      white-space: nowrap;\n    }\n  }\n\n  .sn-select-list {\n    .ant-select {\n      .ant-select-selector {\n        background-color: #f4f4f4;\n      }\n    }\n  }\n\n  .dropdown-button-radius {\n    .ant-btn {\n      width: 70px;\n      border-top-left-radius: 32px;\n      border-bottom-left-radius: 32px;\n    }\n\n    .ant-dropdown-trigger {\n      width: 70px;\n      border-top-right-radius: 32px;\n      border-bottom-right-radius: 32px;\n    }\n  }\n\n  .dropdown-button-radius-large {\n    .ant-btn {\n      width: 100px;\n      border-top-left-radius: 32px;\n      border-bottom-left-radius: 32px;\n    }\n\n    .ant-dropdown-trigger {\n      width: 70px;\n      border-top-right-radius: 32px;\n      border-bottom-right-radius: 32px;\n    }\n  }\n\n  .span-d-wd-100 {\n    display: inline-block;\n    width: 100%;\n  }\n\n  .primary {\n    color: @primary;\n  }\n\n  .br-20 {\n    border-radius: 20px;\n  }\n\n  .pd-10 {\n    padding: 10px;\n  }\n\n  .ml-7 {\n    margin-left: -7.5px;\n    margin-right: -7.5px;\n  }\n\n  .ant-pro-page-container.container-no-bg {\n    background-color: transparent;\n\n    .ant-pro-page-container-children-container {\n      padding: 0px !important;\n\n      #installerPage {\n        padding: 0px !important;\n      }\n    }\n  }\n\n  .ellipsis-text {\n    display: inline-block;\n    width: 100%;\n    text-overflow: ellipsis;\n    overflow: hidden;\n  }\n\n  .pd-t-12 {\n    padding-top: 12px;\n  }\n\n  .logo-width {\n    width: 230px;\n    display: flex;\n    justify-content: center;\n  }\n\n  .header-logo-width-zh {\n    img {\n      width: 110px;\n      height: 50px;\n    }\n  }\n\n  .header-logo-width-en {\n    img {\n      width: 125px;\n      height: 70px;\n    }\n  }\n\n  .ant-pro-global-header-logo-mobile {\n    display: none;\n  }\n\n  .ant-picker,\n  .ant-select:not(.ant-select-customize-input) .ant-select-selector {\n    border-radius: 5px;\n  }\n\n  .suspense-spin-loading {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n  }\n\n  .ml-12 {\n    margin-left: 12px;\n  }\n\n  .fSize-16 {\n    font-size: 16px;\n  }\n\n  .fSize-14 {\n    font-size: 14px;\n  }\n\n  @media screen and (max-width: 767px) {\n    .dashboard-editor-container,\n    #clone-dom {\n      .diagram-pic-container .single-item,\n      .diagram-pic-container ul.diagram-data {\n        transform: scale(0.6);\n        -ms-transform: scale(0.6);\n        -moz-transform: scale(0.6);\n        -webkit-transform: scale(0.6);\n        -o-transform: scale(0.6);\n      }\n\n      .energy-diagram .diagram-pic-container .diagram-data-generator,\n      .diagram-pic-container .diagram-data-windpower {\n        top: -10%;\n      }\n\n      .diagram-pic-container .diagram-data-windpower {\n        width: auto;\n        max-width: 120px;\n        word-break: normal;\n      }\n\n      .energy-diagram {\n        .diagram-pic-container {\n          .diagram-data-num1,\n          .diagram-data-num4 {\n            left: 12%;\n          }\n\n          .diagram-data-num2,\n          .diagram-data-num5 {\n            right: 12%;\n          }\n\n          .diagram-data-num1,\n          .diagram-data-num2 {\n            top: 35%;\n          }\n\n          .diagram-data-num5,\n          .diagram-data-num4 {\n            top: 75%;\n          }\n        }\n      }\n\n      .energy-diagram-content {\n        svg {\n          height: 100% !important;\n        }\n      }\n    }\n  }\n\n  #line_chart_01,\n  #data-analysis-chart {\n    canvas:hover {\n      cursor: default;\n    }\n  }\n\n  .dashboard-editor-container,\n  #clone-dom {\n    .ant-picker.ant-picker-small {\n      border-radius: 12px;\n    }\n\n    .ant-picker-input > input {\n      color: rgba(0, 0, 0, 0.28);\n    }\n  }\n\n  .power_charts {\n    .ant-radio-group {\n      & > label:first-child {\n        border-top-left-radius: 15px;\n        border-bottom-left-radius: 15px;\n      }\n\n      & > label:last-child {\n        border-top-right-radius: 15px;\n        border-bottom-right-radius: 15px;\n      }\n\n      & > .ant-radio-button-wrapper-checked {\n        background-color: #fabf00;\n        color: @primary-black;\n      }\n\n      & > label {\n        font-size: 12px;\n      }\n    }\n  }\n\n  .ant-select-selection-search {\n    input {\n      border-radius: 5px;\n    }\n  }\n\n  .ant-form-item-control-input-content {\n    .ant-input-affix-wrapper {\n      border-radius: 5px;\n    }\n  }\n\n  .ant-picker-range {\n    border-radius: 5px;\n  }\n\n  .ant-form-item-control-input-content {\n    input {\n      border-radius: 5px;\n    }\n  }\n\n  #_resetZoom_echart_customer {\n    &:hover {\n      background-color: #f7f7f7;\n    }\n  }\n\n  .ant-card {\n    width: 100%;\n  }\n\n  li {\n    list-style: none;\n  }\n\n  .search-condition {\n    margin: 20px 0px;\n\n    .date {\n      text-align: right;\n    }\n  }\n\n  .pagination-container {\n    width: 100%;\n    text-align: right;\n    margin-top: 20px;\n  }\n\n  .flex {\n    display: -webkit-box;\n    display: -moz-flex;\n    display: -ms-flexbox;\n    display: flex;\n  }\n\n  .profi_title {\n    line-height: 60px;\n    text-align: left;\n    padding-left: 2%;\n    font-size: 2rem;\n    color: #f8d27d;\n    text-shadow: 6px 3px 3px #824f4f;\n  }\n\n  .profi_progress {\n    line-height: 30px;\n    font-size: 12px;\n    margin: 3% 0 0;\n    padding-right: 0.5%;\n  }\n\n  .customer-card-style-index {\n    .bg-white {\n      background: #fff;\n      padding: 10px;\n      border-radius: 20px;\n\n      .ant-card {\n        // color: rgba(0, 0, 0, 0.45);\n        border-radius: 20px;\n        background: @elCardBg;\n\n        .ant-card-header {\n          border-bottom: 0px;\n          padding: 12px 12px 0px 12px;\n        }\n\n        .ant-card-body {\n          padding-left: 12px;\n          padding-right: 12px;\n        }\n\n        .ant-card-head-title {\n          color: rgba(0, 0, 0, 0.45);\n          font-size: 14px;\n          font-weight: 600;\n\n          span.title {\n            // padding-bottom: 5px;\n            margin-right: 10px;\n            font-size: 16px;\n            font-weight: 400;\n            line-height: 24px;\n            color: #868686;\n\n            &.active {\n              font-size: 16px;\n              font-weight: 600;\n              line-height: 24px;\n              color: #454545;\n              border-bottom: 2px solid @primary;\n            }\n\n            &.pointer {\n              cursor: pointer;\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n.ant-spin-nested-loading {\n  height: 100%;\n\n  .ant-spin-container {\n    // display: flex;\n    height: 100%;\n    // flex-direction: column;\n\n    .ant-table {\n      flex: 1;\n\n      .ant-table-container {\n        height: 100%;\n\n        .ant-table-content {\n          height: 100%;\n        }\n      }\n    }\n  }\n}\n\n.ant-table-thead > tr > th {\n  background: #fff;\n  font-weight: bold; //表格-表头-加粗\n}\n\n.ant-table-thead\n  > tr\n  > th:not(:last-child):not(.ant-table-selection-column):not(.ant-table-row-expand-icon-cell):not([colspan])::before {\n  background-color: inherit !important;\n}\n\n.auto-table .ant-table-body {\n  overflow: auto !important;\n}\n/* table高度自适应布局 */\n.custom-contant {\n  display: flex;\n  min-height: calc(100vh - 140px);\n  flex-direction: column;\n  /* 普通情况下：只有查询表单 */\n  .custom-table-flex {\n    flex: 1;\n\n    .detail-table-flex {\n      .ant-table-content {\n        min-height: 100% !important;\n      }\n    }\n    .ant-spin-nested-loading {\n      height: 100%;\n\n      .ant-spin-container {\n        display: flex;\n        height: 100%;\n        flex-direction: column;\n\n        .ant-table {\n          flex: 1;\n\n          .ant-table-container {\n            height: 100%;\n\n            // .ant-table-body{\n            //   height: 100px;\n            //   overflow-y: auto;\n            //   // min-height: calc(100vh - 380px);\n            // }\n            .ant-table-content {\n              min-height: calc(100vh - 300px);\n            }\n          }\n        }\n\n        .ant-table-thead > tr > th {\n          background: #fff;\n          font-weight: bold; //表格-表头-加粗\n        }\n\n        .ant-table-ping-right:not(.ant-table-has-fix-right) > .ant-table-container::after,\n        .ant-table-ping-left:not(.ant-table-has-fix-left) > .ant-table-container::before {\n          box-shadow: none;\n        }\n\n        .ant-table-thead\n          > tr\n          > th:not(:last-child):not(.ant-table-selection-column):not(.ant-table-row-expand-icon-cell):not(\n            [colspan]\n          )::before {\n          background-color: inherit !important;\n        }\n      }\n    }\n  }\n\n  /* 修改列表查询条件 */\n  .custom-search {\n    padding: 10px 0;\n    margin-bottom: 10px;\n\n    .ant-form-item {\n      margin-bottom: 0px;\n    }\n    .ant-form-item-label {\n      padding: 8px 0;\n    }\n  }\n\n  /* 布局里面包含tabs标签页的时候 */\n  .ant-tabs-content-holder {\n    height: 100%;\n\n    .ant-tabs-content {\n      height: 100%;\n\n      .ant-tabs-tabpane-active {\n        display: flex;\n        height: 100%;\n        flex-direction: column;\n      }\n    }\n  }\n}\n\n/* 修改左侧样式背景 */\n.ant-pro-sider {\n  background-color: #fff !important;\n}\n\n.ant-layout-content {\n  background-color: #f5f5f5 !important;\n  // box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);\n}\n\n.ant-pro-page-container {\n  background-color: #fff;\n  border-radius: 10px;\n  margin: 10px;\n  // box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);\n}\n\n.page-shadow {\n  box-shadow: 0px 1px 10px rgba(0, 0, 0, 0.15);\n}\n\n.system-left-list {\n  box-shadow: 0px 1px 10px rgba(0, 0, 0, 0.15) !important;\n  // .ant-pagination .ant-pagination-mini::-webkit-scrollbar-track{\n  //   background-color: red;\n  //   // opacity: 0;\n  // }\n}\n\n.system-tabs {\n  .ant-tabs-content-holder {\n    box-shadow: 0px 1px 10px rgba(0, 0, 0, 0.15);\n  }\n}\n\n.ant-page-header {\n  border-bottom: 1px solid #ebeef5;\n}\n\n/* 操作里面删除文字样式 */\n.delete-text {\n  color: red;\n}\n\n.green {\n  color: #87ca16;\n}\n\n.execute-btn {\n  color: #1dc7ea;\n\n  &:hover {\n    cursor: pointer;\n  }\n\n  font-size: 14px;\n\n  &.is-disabled {\n    color: #c0c4cc;\n    cursor: not-allowed;\n    background-image: none;\n  }\n}\n\n.detail-btn {\n  color: #87ca16 !important;\n  display: inline-block;\n  margin-right: 10px;\n\n  &:hover {\n    cursor: pointer;\n  }\n\n  font-size: 14px;\n}\n\n/* 表单项垂直布局时，按钮位置下移 */\n.move-down-button {\n  margin-top: 30px;\n}\n\n/* 修改手风琴样式 */\n.custom-collapse {\n  background-color: transparent !important;\n\n  .ant-collapse-item {\n    border-bottom: 1px solid #ebeef5 !important;\n  }\n\n  .ant-collapse-item:last-child {\n    border-bottom: 0px !important;\n  }\n}\n\n.updateLog-collapse {\n  .ant-collapse-expand-icon::before {\n    content: '*';\n    color: red;\n    margin-right: 4px;\n  }\n}\n\n/* 表单设置一行展示 */\n.custom-inline {\n  .ant-form-item-row {\n    flex-direction: inherit !important;\n  }\n\n  .ant-form-item-control {\n    width: auto !important;\n    margin: -4px 0 0 8px;\n  }\n}\n\n.custom-form-item {\n  // .ant-switch {\n  //   min-width: 65px;\n  // }\n\n  .custom-tooltip {\n    margin-left: 10px;\n    vertical-align: middle;\n\n    .anticon-info-circle {\n      margin-left: 5px;\n      color: rgba(0, 0, 0, 0.45);\n    }\n  }\n}\n\n/* 设置右侧内容区域填充 */\n.ant-pro-page-container-children-content {\n  padding-inline: 10px;\n}\n\n/* 全局设置公共样式 */\n.mr10 {\n  margin-right: 10px;\n}\n\n.ml8 {\n  margin-left: 8px;\n}\n\n.mt10 {\n  margin-top: 10px;\n}\n\n.mb10 {\n  margin-bottom: 10px;\n}\n\n.ml50 {\n  margin-left: 50px;\n}\n\n.input-number-width {\n  width: 100% !important;\n}\n\n.input-number-small {\n  display: inline-block;\n\n  .ant-input-number {\n    width: 100% !important;\n  }\n}\n.content-html.dg-html {\n}\n.input-number-big {\n  display: inline-block;\n  width: 75%;\n}\n\n.current-setting {\n  display: inline-block;\n}\n\n.in-line-style {\n  .padding-tope-style {\n    padding-top: 10px;\n  }\n}\n.red-star {\n  color: #ff4d4f;\n}\n/* 自定义form表单下按钮靠右对齐 */\n.custom-form-btn {\n  margin: 20px -24px 0 -24px;\n  padding: 10px 24px 0 24px;\n  text-align: right;\n  border-top: 1px solid #f0f0f0;\n\n  .ant-btn-default {\n    margin-right: 8px;\n  }\n}\n\n.m-b-xs {\n  margin-bottom: 8px !important;\n}\n\n.has-file-upload {\n  .ant-form-item-control {\n    position: relative;\n\n    .vir-btn {\n      position: absolute;\n      left: 4px;\n      top: 8px;\n      height: 28px;\n      line-height: 28px;\n      min-width: 80px;\n      z-index: 3;\n      text-align: center;\n      border: 1px solid #ccc;\n      background-color: #f8f8f8;\n      padding: 0px 6px;\n    }\n\n    input {\n      position: absolute;\n      left: 0px;\n      top: 0px;\n      height: 28px;\n      line-height: 28px;\n      width: 80px;\n      z-index: 10;\n      opacity: 0;\n    }\n\n    span {\n      display: inline-block;\n      margin-left: 90px;\n    }\n  }\n}\n\n/* 自定义form表单边框 */\n.custom-border {\n  padding: 15px 25px;\n  border: 1px solid #ccc;\n}\n\n.custom-btn {\n  text-align: right;\n  margin-top: 20px;\n\n  .ant-btn {\n    margin-right: 12px;\n  }\n}\n\n/* 自定义研发数据调试调试数据一行显示五个 */\n.custom-research-data {\n  padding: 10px 5px;\n\n  .ant-col-4 {\n    max-width: 20%;\n    flex: 0 0 20%;\n\n    p:first-child {\n      margin-bottom: 4px;\n    }\n  }\n}\n\n/* 自定义数据报表生成状况 */\n.report-day {\n  width: 100%;\n\n  ul {\n    padding-inline-start: 0px;\n    padding: 4px 10px;\n  }\n\n  li {\n    list-style: none;\n    width: 10%;\n    display: inline-block;\n    border-bottom: 1px solid #e4e7ed;\n    padding: 8px 10px 0 10px;\n    height: 66px;\n    vertical-align: top;\n\n    .ant-btn {\n      text-align: left;\n      padding: 0px;\n    }\n  }\n\n  .report-day-bg {\n    background: #dff0d8;\n\n    .report-day-regenerate {\n      color: #ff4a55;\n    }\n  }\n\n  .report-day-generate {\n    color: #1dc7ea;\n  }\n}\n\n.report-status {\n  border: 1px solid #f0f0f0;\n  border-radius: 10px;\n  padding: 10px 0;\n\n  .title {\n    font-weight: bold;\n    border-bottom: 1px solid #f0f0f0;\n    padding: 0 10px 10px;\n  }\n\n  .ant-form,\n  .ant-table-wrapper {\n    padding: 0 10px;\n  }\n}\n\n.report-table {\n  .ant-table-tbody > tr > td[title='N'] {\n    background: #f2dede !important;\n\n    &:hover {\n      background: #ebcccc !important;\n    }\n  }\n\n  .ant-table-tbody > tr > td[title='Y'] {\n    background: #dff0d8 !important;\n\n    &:hover {\n      background: #d0e9c6 !important;\n    }\n  }\n\n  .ant-table-tbody > tr > td:first-child {\n    background: none;\n\n    &:hover {\n      background: none;\n    }\n  }\n}\n\n/* 公共样式 */\n.text-right {\n  text-align: right;\n}\n\n.text-center {\n  text-align: center;\n}\n\n.common-radius {\n  border-radius: 30px;\n  padding: 2px 14px;\n}\n\n.ant-tooltip {\n  max-width: 670px;\n\n  img {\n    max-width: 640px;\n  }\n}\n\n/* 左侧菜单选中时样式 */\n.ant-layout-sider .ant-menu-item-selected,\n.ant-layout-sider .ant-menu-submenu .ant-menu-item-selected,\n.ant-menu-item:active,\n.ant-menu-submenu-title:active {\n  background-color: rgb(245, 245, 245) !important;\n  color: rgba(0, 0, 0, 0.8) !important;\n  background: url('/public/common/img/menu-border-img.png') no-repeat;\n  background-size: 4px 100%;\n  font-weight: bold;\n}\n\n.ant-layout-sider .ant-menu-light .ant-menu-submenu-title:hover,\n.ant-menu-submenu:hover > .ant-menu-submenu-title > .ant-menu-submenu-arrow {\n  color: rgba(0, 0, 0, 0.8) !important;\n}\n\n.ant-layout-sider-children {\n  height: 92% !important;\n  padding-inline: 0px !important;\n  border-inline-end: 0px !important;\n}\n\n.ant-menu-sub.ant-menu-inline {\n  background: #ffffff;\n}\n\n.ant-menu-title-content a {\n  color: rgba(0, 0, 0, 0.85) !important;\n}\n\n.ant-menu-submenu-selected {\n  color: rgba(0, 0, 0, 0.8) !important;\n}\n\n.ant-menu-vertical .ant-menu-item::after,\n.ant-menu-vertical-left .ant-menu-item::after,\n.ant-menu-vertical-right .ant-menu-item::after,\n.ant-menu-inline .ant-menu-item::after {\n  border: 0px !important;\n}\n\n.ant-menu-sub {\n  padding-inline-start: 0px !important;\n}\n\n.ant-layout-sider-children div:first-child {\n  // margin-right: -5px;\n}\n\n.ant-layout-sider-children > :first-child {\n  overflow: hidden !important;\n}\n\n.ant-layout-sider-children > :first-child:hover {\n  overflow: hidden auto !important;\n}\n\n.ant-layout-sider-children > :first-child::-webkit-scrollbar {\n  width: 6px;\n  border-radius: 4px;\n  background-color: rgba(0, 0, 0, 0.05);\n}\n\n.ant-layout-sider-children > :first-child::-webkit-scrollbar-thumb {\n  width: 10px;\n  border-radius: 10px;\n  background-color: rgba(0, 0, 0, 0.25);\n  // box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.5);\n}\n\n.ant-pro-layout {\n  .ant-pro-sider.ant-pro-sider-fixed-mix {\n    height: 100% !important;\n  }\n}\n\n.language-zh {\n  .ant-menu-submenu-arrow {\n    left: 190px;\n  }\n}\n\n.ant-layout-sider-collapsed {\n  .ant-menu-submenu,\n  .ant-menu-item {\n    width: 20px;\n    margin: 0 auto;\n    overflow: hidden;\n    background-color: none !important;\n    background: none !important;\n  }\n}\n\n.ant-menu-submenu-selected {\n  .ant-menu-submenu-title {\n    background: none !important;\n  }\n}\n\n.language-en {\n  .ant-menu-submenu-arrow {\n    left: 230px;\n  }\n}\n\n// .ant-menu-submenu:hover,\n// .ant-menu-item:hover {\n//   background-color: rgb(245, 245, 245) !important;\n// }\n.ant-menu-submenu:hover,\n.ant-menu-item a:hover {\n  color: rgba(0, 0, 0, 0.8) !important;\n}\n\n// .ant-menu-submenu:hover,\n// .ant-menu-item:hover {\n//   background-color: rgb(245,245,245) !important;\n// }\n// .ant-menu-submenu:hover,\n// .ant-menu-item a:hover {\n//   color: rgba(0, 0, 0, 0.8) !important;\n// }\n\n/* 自定义Modal全屏样式 */\n.common-full {\n  padding: 20px;\n}\n\n.common-full,\n.common-exit {\n  position: inherit !important;\n  background: #fff;\n\n  .common-full-screen {\n    cursor: pointer;\n    position: absolute;\n    top: 22px;\n    right: 55px;\n    z-index: 999;\n  }\n}\n\n.ant-layout-header {\n  border-bottom-right-radius: 15px !important;\n  // background-color: #f5f5f5 !important;\n}\n\n/* 顶部导航，左侧菜单圆角样式 */\n.ant-layout-sider,\n.ant-pro-layout .ant-layout-header.ant-pro-layout-header-fixed-header {\n  border-bottom-right-radius: 15px;\n}\n\n.common-ellipsis {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n/* 定义滚动条样式 */\n::-webkit-scrollbar {\n  width: 6px !important;\n  height: 6px !important;\n  background-color: rgba(0, 0, 0, 0.05) !important;\n}\n\n/*定义滚动条轨道 内阴影*/\n::-webkit-scrollbar-track {\n  box-shadow: inset 0 0 0px rgba(240, 240, 240, 0.3) !important;\n  background-color: rgba(0, 0, 0, 0.05) !important;\n}\n\n/*定义滑块 内阴影*/\n::-webkit-scrollbar-thumb {\n  border-radius: 10px !important;\n  box-shadow: inset 0 0 0px rgba(240, 240, 240, 0.3) !important;\n  background-color: rgba(0, 0, 0, 0) !important;\n  opacity: 0 !important;\n}\n\n:hover::-webkit-scrollbar-thumb {\n  background-color: rgba(0, 0, 0, 0.25) !important;\n  opacity: 1 !important;\n}\n\n.common-procard {\n  .ant-pro-card-body {\n    padding-inline: inherit !important;\n  }\n}\n\n.ant-pro-field-index-column-border {\n  background-color: inherit !important;\n  color: #000;\n  font-size: 14px;\n}\n\n/* 系统右侧内容区域 */\n.ant-pro-layout .ant-pro-layout-content {\n  padding-block: 4px;\n  padding-inline: 10px;\n}\n\n/* 统一修改日期控件颜色 */\n.ant-picker-input > input {\n  color: rgba(0, 0, 0, 0.85) !important;\n}\n\n/* 首页更新通知 */\n.notice-box {\n  font-family: 'PingFang SC';\n  font-style: normal;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 22px;\n  white-space: pre-line;\n}\n\n.notice-yellow {\n  color: #fabf00;\n  border-bottom: 2px solid #fabf00;\n  padding-bottom: 2px;\n  cursor: pointer;\n}\n\n.checkbox-checked-color-change {\n  .ant-checkbox-wrapper-checked {\n    color: #facb00 !important;\n  }\n}\n\n.light-green {\n  color: rgb(135, 202, 22) !important;\n}\n\n.ant-picker-input > input[disabled] {\n  color: rgba(0, 0, 0, 0.25) !important;\n}\n\n// 更新日志全屏滚动\n#clone-dom {\n  overflow-y: auto;\n  height: 100%;\n  width: 100%;\n  overflow-x: hidden;\n  padding-top: 10px;\n}\n\n.ant-modal-content {\n  border-radius: 4px;\n\n  .ant-modal-body {\n    padding: 15px 10px 10px;\n\n    .ant-modal-confirm-body-wrapper {\n      .ant-btn-default {\n        height: 32px;\n        padding: 4px 16px;\n        font-size: 14px;\n        border-radius: 32px;\n      }\n\n      .ant-btn-primary {\n        height: 32px;\n        padding: 4px 16px;\n        font-size: 14px;\n        border-radius: 32px;\n      }\n    }\n  }\n}\n\n.energy-title {\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 24px;\n  color: #2e2e2e;\n}\n\n.ant-page-header {\n  border-top-left-radius: 10px;\n  border-top-right-radius: 10px;\n}\n\n.system-message-radio {\n  overflow: hidden;\n}\n\n#energy-diagram {\n  .ant-picker {\n    border-radius: 20px;\n  }\n}\n\n/* antd confirm弹窗去掉取消按钮的样式 */\n.ant-modal-confirm-btns-delete {\n  .ant-modal-confirm-btns {\n    .ant-btn-default {\n      display: none;\n    }\n  }\n}\n\n@primary-color: #FABF00;@input-placeholder-color: #868686;@btn-primary-color: #454545;@checkbox-check-color: #454545;@checkbox-color: #E8AA0D;@radio-button-bg: #E8AA0D;@radio-button-checked-bg: #E8AA0D;@radio-button-color: #454545;@radio-button-active-color: #454545;@radio-solid-checked-color: #454545;@font-family: 'WenQuanYi Micro Hei', 'Micro Hei','Noto Sans CJK','Source Han Sans','Montserrat','Roboto','Lato','sans-serif';@btn-text-shadow: 0 0 0 rgba(0, 0, 0, 0);"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
